// extracted by mini-css-extract-plugin
export default {"searchResults":"bs_lh","resultsMessage":"bs_lj","breadcrumb":"bs_lk","isOpen":"bs_hZ","hitCount":"bs_ll","hasResults":"bs_lm"};